module.exports = __webpack_public_path__ + "static/media/revision.de361700.svg";